module.exports = __webpack_public_path__ + "static/media/home.f8d7db11.svg";